import { createFileRoute } from "@tanstack/react-router";
import { LeadsTab } from "@/components/admin/LeadsTab";

export const Route = createFileRoute("/admin/leads")({
  head: () => ({ meta: [{ title: "Leads · Admin · INFLOW Marketing" }, { name: "description", content: "Every inquiry from the funnel, scored and editable." }, { name: "robots", content: "noindex,nofollow" }] }),
  component: () => (
    <div className="space-y-6">
      <div>
        <h1 className="font-serif text-3xl tracking-tight">Leads</h1>
        <p className="text-sm text-muted-foreground mt-1">Every inquiry from the funnel, scored and editable.</p>
      </div>
      <LeadsTab />
    </div>
  ),
});
